function distanceFromTop(targetRect, popoverRect) {
  return targetRect.top - popoverRect.height;
}
function distanceFromBottom(targetRect, popoverRect) {
  return window.innerHeight - targetRect.bottom - popoverRect.height;
}
function distanceFromLeft(targetRect, popoverRect) {
  return targetRect.left - popoverRect.width;
}
function distanceFromRight(targetRect, popoverRect) {
  return window.innerWidth - targetRect.right - popoverRect.width;
}
export {
  distanceFromBottom,
  distanceFromLeft,
  distanceFromRight,
  distanceFromTop
};
